import { IconAlertCircleFilled, IconCircleCheckFilled } from '@tabler/icons-react';

import type { VendorAvailabilityListItem } from '../types';
import { getListItemStatus } from '../helpers';

type StatusIconProps = {
  item: VendorAvailabilityListItem;
  size?: number;
};

const StatusIcon: React.FC<StatusIconProps> = ({ item, size = 14 }) => {
  const { isMissedDeadline, isActionRequired } = getListItemStatus(item);

  if (isMissedDeadline) {
    return <IconAlertCircleFilled size={size} color="red" />;
  }
  if (isActionRequired) {
    return <IconAlertCircleFilled size={size} color="orange" />;
  }
  return <IconCircleCheckFilled size={size} color="var(--mantine-color-teal-6)" />;
};

export default StatusIcon;
